import React, { useEffect, useState } from 'react'
import Loader from 'react-loader-spinner'
import { global } from './constants'
import { fetchResponse } from '../../controllers/shared/utils/fetch_data'
import { SearchResultItem } from './SearchResultItem'
import { SearchResultNewClient } from './SearchResultNewClient'
import { Suggestions } from './Suggestions'

export default function SearchResults({
  inputText,
  searchResults,
  adminSiteIds,
  usesAdvancedSiteManagement,
  onClick,
  onNewClientSelected,
  suggestions,
  loading,
  showRecentResults
}) {
  const recentlySearchedIds = JSON.parse(localStorage.getItem(`people_searched_${global.organizationId}`))
  const hasRecentSearches =  showRecentResults && recentlySearchedIds && recentlySearchedIds.length > 0

  const [peoplePersonalInfo, setPeoplePersonalInfo] = useState([])
  const [recentSearch, setRecentSearch] = useState([])
  const [loadingRecentSearch, setLoadingRecentSearch] = useState(hasRecentSearches)
  const hasSuggestions = suggestions && suggestions.results && suggestions.results.length > 0

  useEffect(() => {
    if (searchResults.result?.length > 0) {
      getPeoplePersonalInfo(searchResults).then(data => setPeoplePersonalInfo(data))
    }
  }, [searchResults?.result])

  useEffect(() => {
    if (!hasSuggestions) {
      if (recentlySearchedIds && recentlySearchedIds.length > 0) {
        const urlParams = new URLSearchParams(recentlySearchedIds.map(id => ['people_ids[]', id]))

        fetchResponse(`/admin/org/people/global_search_suggestions?${urlParams}`)
          .then(response => response.json())
          .then(data => {
            setRecentSearch(data)
            setLoadingRecentSearch(false)
          })
      } else {
        setLoadingRecentSearch(false)
      }
    }
  }, [])

  async function getPeoplePersonalInfo(searchResults) {
    const people_ids = searchResults.result.map((person, _) => person.id)
    const urlParams = new URLSearchParams(people_ids.map(id => ['people_ids[]', id]))
    const response = await fetchResponse(`/admin/org/people/global_search?${urlParams}`)

    if (response.status === 200) {
      return response.json()
    } else {
      return []
    }
  }

  if (!showRecentResults) {
    return null
  }

  if (loading || loadingRecentSearch) {
    return (
      <div className='text-center search-results position-absolute'>
        <Loader type='ThreeDots' color='#00BFFF' height={80} width={80} />
      </div>
    )
  }

  if (!inputText) {
    if (!suggestions) {
      if (recentSearch && recentSearch.results && recentSearch.results.length > 0) {
        return (
          <Suggestions
            suggestions={recentSearch}
            adminSiteIds={adminSiteIds}
            usesAdvancedSiteManagement={usesAdvancedSiteManagement}
            onClick={onClick}
          />
        )
      } else {
        return null
      }
    }

    if (suggestions.results.length === 0) return null

    return (
      <Suggestions
        suggestions={suggestions}
        adminSiteIds={adminSiteIds}
        usesAdvancedSiteManagement={usesAdvancedSiteManagement}
        onClick={onClick}
      />
    )
  }

  if (!searchResults || (searchResults && searchResults.loading)) {
    return (
      <div className='text-center search-results position-absolute'>
        <Loader type='ThreeDots' color='#00BFFF' height={80} width={80} />
      </div>
    )
  }

  if (
    (searchResults.result && searchResults.result.error) ||
    !searchResults.result ||
    searchResults.result.length === 0
  ) {
    return (
      <div className='text-center search-results position-absolute'>
        <p className='text-muted'>No results. Refine your search</p>
        {onNewClientSelected && <SearchResultNewClient onSelect={onNewClientSelected} />}
      </div>
    )
  }

  return (
    <div role='table' className='search-results position-absolute'>
      <div role='rowgroup'>
        {/* column header for screen readers */}
        <div role='row' className='visually-hidden'>
          <div role='columnheader'>Name</div>
          <div role='columnheader'>Birthday and Age</div>
          <div role='columnheader'>Address</div>
          <div role='columnheader'>Contact Info</div>
          <div role='columnheader'>Roles</div>
          <div role='columnheader'>Contacts</div>
          <div role='columnheader'>Actions</div>
        </div>
        {searchResults.result.map((person, idx) => (
          <SearchResultItem
            key={idx}
            person={person}
            personalInfo={peoplePersonalInfo.find(p => p.id === person.id)}
            position={idx + 1}
            adminSiteIds={adminSiteIds}
            usesAdvancedSiteManagement={usesAdvancedSiteManagement}
            onClick={onClick}
          />
        ))}
      </div>
      {onNewClientSelected && <SearchResultNewClient onSelect={onNewClientSelected} />}
    </div>
  )
}
